import antd from 'ant-design-vue/es/locale-provider/ar_EG';
import dayjsLocale from 'dayjs/locale/ar';
import momentEnCA from 'moment/dist/locale/ar';
import data from '../json/ar.json';

const components = {
  antLocale: antd,
  momentName: 'ar',
  momentLocale: momentEnCA,
  dayjsName: 'ar',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
